import { useStyledTheme } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { AnimatedRippleCirle } from './animated-ripple-circle';
import { bc, borderColor as borderColorUtil } from '../../style-utils';
import { CircleIcon, CircleIconProps } from '../circle-icon/circle-icon';

export type AnimatedRippleCircleIconProps = Pick<
  CircleIconProps,
  | 'name'
  | 'solid'
  | 'size'
  | 'iconSize'
  | 'color'
  | 'borderColor'
  | 'backgroundColor'
> & {
  rippleColor?: string;
  rippleBackgroundColor?: string;
  containerStyle?: StyleProp<ViewStyle>;
};

export const AnimatedRippleCircleIcon = ({
  size = 50,
  iconSize = 25,
  color = '#000',
  rippleColor = '#000',
  rippleBackgroundColor = '#fff',
  borderColor = '#000',
  backgroundColor = '#fff',
  containerStyle,
  ...props
}: AnimatedRippleCircleIconProps) => {
  const theme = useStyledTheme();

  return (
    <View style={containerStyle}>
      <AnimatedRippleCirle
        size={size}
        borderColor={rippleColor}
        backgroundColor={rippleBackgroundColor}
      />
      <AnimatedRippleCirle
        size={size}
        borderColor={rippleColor}
        backgroundColor={rippleBackgroundColor}
        delay={1000}
      />
      <CircleIcon
        {...props}
        size={size}
        iconSize={iconSize}
        color={color}
        borderColor={borderColor}
        backgroundColor={backgroundColor}
        style={[bc(theme.color.lightBackground), borderColorUtil(borderColor)]}
      />
    </View>
  );
};
